import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";	
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
var Constants = require("../constants.json");

const Banner = (props) => {
  const [searchkey, setSearchkey] = useState("");
  const genusSelected = localStorage.getItem("genus") ? localStorage.getItem("genus") : Constants["defaultGenus"];
  const [genus, setGenus] = useState(genusSelected);
  const optionList = props.optionList;
  const genusList = useSelector(state => state.genusReducer);	
  let focusOutTimer;

  useEffect(()=>{
    return()=>{clearTimeout(focusOutTimer)}
  })

  function changeSearchkey(e) {
    let srchkey = e.target.value;
    setSearchkey(srchkey);
    props.changeSearchkey(srchkey);
  }
  function handleSearchTopicSubmit(e) {
    e.preventDefault();
    if (
      document.querySelector(
        ".autosuggest .autosuggest-container ul li.selected"
      ) === null
    ) {
      if (searchkey !== "") {
        props.onFormSubmit({ searchkey: searchkey, searchgenus: genus });
      }
    } else {
      document
        .querySelector(".autosuggest .autosuggest-container ul li.selected a")
        .click();
    }
  }
  function handleGenusChange(ge) {
    setGenus(ge);
    localStorage.setItem("genus", ge);
    if (searchkey !== "") {
      props.onFormSubmit({ searchkey: searchkey, searchgenus: ge });
    }
  }

  const inputKeyPress = (event) => {
    document.querySelector(".autosuggest").style.display = "block";
    let srchOptions = document.querySelectorAll(
      ".autosuggest .autosuggest-container ul li"
    );
    if (document.querySelector(".autosuggest .autosuggest-container") != null) {
      if (event.keyCode === 38) {
        // console.log("up arrow");
        event.preventDefault();
        if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ) === null
        ) {
          document
            .querySelector(
              `.autosuggest .autosuggest-container ul li#\\3${
                srchOptions.length - 1
              }`
            )
            .classList.add("selected");
        } else if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ).id === "0"
        ) {
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
        } else {
          let currentSelectedId = Number(
            document.querySelector(
              ".autosuggest .autosuggest-container ul li.selected"
            ).id
          );
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
          document
            .querySelector(
              `.autosuggest .autosuggest-container ul li#\\3${
                (currentSelectedId - 1) % srchOptions.length
              }`
            )
            .classList.add("selected");
        }
      } else if (event.keyCode === 40) {
        event.preventDefault();
        // console.log("down arrow");
        if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ) === null
        ) {
          document
            .querySelector(`.autosuggest .autosuggest-container ul li#\\30`)
            .classList.add("selected");
        } else if (
          document.querySelector(
            ".autosuggest .autosuggest-container ul li.selected"
          ).id ===
          (srchOptions.length - 1).toString()
        ) {
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
        } else {
          let currentSelectedId = Number(
            document.querySelector(
              ".autosuggest .autosuggest-container ul li.selected"
            ).id
          );
          document
            .querySelector(".autosuggest .autosuggest-container ul li.selected")
            .classList.remove("selected");
          document
            .querySelector(
              `.autosuggest .autosuggest-container ul li#\\3${
                (currentSelectedId + 1) % srchOptions.length
              }`
            )
            .classList.add("selected");
        }
      }
    }
  };

  const inputFocusOut = () => {
    focusOutTimer=setTimeout(() => {
      document.querySelector(".autosuggest").style.display = "none";
    }, 200);
  };

  return (
    <div className="banner">
      <div className="banner-content">
        <p className="banner-para">POWERED BY</p>
        <p className="banner-sub-para">
          Blackwell’s 5 Minute Veterinary Consult Series
        </p>
        <h1 className="banner-heading">
          Your Clinical Guide to Veterinary Conditions
        </h1>
        <p className="banner-mobile-para">
          BY Blackwell’s 5 Minute Veterinary Consult Series
        </p>
        {genusList && genusList.response &&	
        <div className="search-input">
          <FontAwesomeIcon icon={faSearch} className="icon" />
          <form
            onSubmit={(e) => handleSearchTopicSubmit(e)}
            className="form-inline"
          >
            <input
              type="text"
              id="srchInput"
              placeholder="What condition do you want to learn about?"
              value={searchkey}
              onChange={changeSearchkey}
              autoComplete="off"
              onBlur={inputFocusOut}
              onKeyUp={inputKeyPress}
            />
            <span className="blue-vert-line"></span>
            <div className="srch-filter" id="sel-genus">
              <select
                className="srch-dropdown"
                value={genus}
                onChange={(e) => handleGenusChange(e.currentTarget.value)}
              >
                {genusList.response.map((genus) => (	
                  <option key={genus.id} value={genus.genus}>	
                    {genus.genus}	
                  </option>	
                ))}
              </select>
            </div>
          </form>
        </div>}
        <div className="autosuggest">{optionList}</div>
      </div>
    </div>
  );
};
export default Banner;
